//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

const loadScript = (id: string, src: string) =>
  // No return value is needed in Promise, but returning a boolean since react-query does not allow to return undefined
  new Promise<boolean>((resolve, reject) => {
    if (!document.getElementById(id)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.id = id;
      script.defer = true;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = reject;
      document.body.appendChild(script);
    } else {
      resolve(true);
    }
  });

export const useScriptLoaderQuery = (
  queryKey: string[],
  scriptId: string,
  scriptUrl: string,
) => {
  return useQuery({
    queryKey: [...queryKey, scriptId, scriptUrl],
    queryFn: () => loadScript(scriptId, scriptUrl),
    staleTime: Infinity,
  });
};
